import { RouteLocationRaw } from "vue-router"
import { useAccountStore } from "@/modules/account/store"
import { useAppConfigStore } from "@/store/appConfig"

export function canAccessUserAnalyticsCourseOverview(): boolean {
  const accountStore = useAccountStore()
  const appConfigStore = useAppConfigStore()

  return !!appConfigStore.settings.module_courses && !!accountStore.rights["courses-stats"]
}

export function canAccessUserAnalyticsAppointmentOverview(): boolean {
  const accountStore = useAccountStore()
  const appConfigStore = useAppConfigStore()

  return !!appConfigStore.settings.module_appointments && (accountStore.rights["appointments-view"] || accountStore.rights["appointments-edit"])
}

export function getUserAnalyticsDetailDefaultRoute(userId: string | string[] | number): RouteLocationRaw {
  return {
    name: canAccessUserAnalyticsCourseOverview() ? "user-analytics-detail-courses" : "user-analytics-detail-certificates",
    params: {
      userId,
    },
  }
}
